"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return AccessEveryone;
    }
});
var _react = /*#__PURE__*/ _interopRequireWildcard(require("react"));
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function AccessEveryone(_param) {
    var title = _param.title, props = _objectWithoutProperties(_param, [
        "title"
    ]);
    return /*#__PURE__*/ _react.createElement("svg", _extends({
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "currentColor",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": !!title
    }, props), title ? /*#__PURE__*/ _react.createElement("title", null, title) : null, /*#__PURE__*/ _react.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M20 4C11.1634 4 4 11.1634 4 20C4 28.8366 11.1634 36 20 36C28.8366 36 36 28.8366 36 20C36 11.1634 28.8366 4 20 4ZM19.8231 6.00109C19.882 6.00037 19.941 6 20 6C24.2256 6 28.014 7.87211 30.581 10.8322L29.55 11.487L26.8042 11.459L24.9543 12.1959L23.7838 11.3884L23.1679 9.06998L21.1425 6.94119L19.8231 6.00109ZM17.6037 6.20428C15.7347 6.52664 13.9926 7.21955 12.4556 8.20464L14.0083 10.0162L16.1256 12.6643L15.8693 17.0378L11.7149 17.8064L9.73236 20.1504L10.6647 22.0859L11.7355 24.0043L15.1008 26.6095L12.5979 30.4077L11.3046 30.9729C13.6929 32.8681 16.7143 34 20 34C27.732 34 34 27.732 34 20C34 17.2142 33.1864 14.6185 31.7838 12.4375L30.1222 13.4929L27.178 13.4629L24.6999 14.45L22.0404 12.6155L21.3663 10.0779L19.8257 8.45872L17.6249 6.89054L17.6037 6.20428ZM9.70613 29.4888L11.2539 28.8124L12.411 27.0565L10.1882 25.3357L8.88904 23.0081L7.36743 19.8496L10.6489 15.9696L13.9644 15.3562L14.0841 13.3137L12.4675 11.2918L10.8495 9.40402C7.87942 11.9712 6 15.7661 6 20C6 23.6612 7.40539 26.9942 9.70613 29.4888Z",
        fill: "currentColor"
    }), /*#__PURE__*/ _react.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M24.9058 16.4121L28.3073 17.8519L30.7279 20.9355L30.3357 24.3844L28.2027 26.5554L26.4604 28.5251L24.1823 30.2435L20.5704 30.9958L18.6184 26.996L19.9562 24.0004L19.1399 21.1548L20.6431 17.2047L24.9058 16.4121ZM22.1129 18.9657L21.246 21.2436L22.0798 24.15L20.8256 26.9585L21.6855 28.7206L23.3357 28.3769L25.0955 27.0494L26.7393 25.1911L28.4263 23.474L28.648 21.5249L27.0527 19.4926L24.6801 18.4884L22.1129 18.9657Z",
        fill: "currentColor"
    }));
}

//# sourceMappingURL=AccessEveryone.js.map